module.exports = __webpack_public_path__ + "img/fodder.271e2c1c.png";